var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{staticClass:"on-off-switch",attrs:{"width":29,"height":18,"bgPosition":_vm.position},on:{"iconClick":_vm.iconClick}})}
var staticRenderFns = []

export { render, staticRenderFns }